import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a8080ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import StoryItem from "@/components/TeamStory/StoryItem.vue";
import { TeamStory } from "@/services/entities/teamStory";


export default /*#__PURE__*/_defineComponent({
  __name: 'StoryList',
  props: {
    stories: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stories, (story, index) => {
        return (_openBlock(), _createBlock(StoryItem, {
          key: story.id,
          story: story
        }, null, 8, ["story"]))
      }), 128))
    ])
  ]))
}
}

})